import 'consumerweb-shim';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import templateData from '../../utility/getTemplateData';
import { hideSpinnerOverlay } from '../../utility/helper';
import PayPalUrl from '../../components/payPalUrl';
import * as AppActions from '../../actions/AppActions';
import {
  localsMessages,
  isMobileHeaderExp,
} from '../../utility/getTemplateData';
import { StyleSheet, css } from 'aphrodite';
import _get from 'lodash/get';
import * as FPT from '../../utility/fpt';
import { sanitize } from '../../utility/domUtils';
import { Icon, Button, Text } from '@paypalcorp/pp-react';
import Illustration from '../../components/illustrations/Illustration';

const messages = localsMessages('errors/paymentComplete') || {};
const cancelAndReturnMessages = localsMessages('common/cancelAndReturn');
const US_CAUSE_HUB_URL = 'https://www.paypal.com/us/fundraiser/hub';
const FUNDRAISER_BUTTON = 'FUNDRAISER_BUTTON';
const CANCEL_AND_RETURN_LINK = 'CANCEL_AND_RETURN_LINK';

const styles = StyleSheet.create({
  errorPage: {
    margin: '25px auto 20px',
  },
  errorMessage1: {
    margin: '40px 65px 10px',
    fontSize: '34px',
    fontWeight: '100',
    lineHeight: '40px',

    '@media (max-width : 473px)': {
      margin: '40px 15px 10px',
    },
    '@media (max-width : 320px)': {
      margin: '40px -15px 10px',
    },
  },
  errorMessage2: {
    margin: '20px auto 20px',
  },
});

class MemberPage extends React.Component {
  state = {};

  componentDidMount() {
    AppActions.updateCurrentPage({ currentPage: 'paymentCompleteError' });
    hideSpinnerOverlay();
  }

  handleReturn = () => {
    // FOR 'US' and 'GB' go to causeHUb
    if (templateData.country === 'US' || templateData.country === 'GB') {
      window.location.href = templateData.causeHubUrl;
      return;
    }
    // For NON-US and NON-GB, default to US behaviour
    window.location.href = US_CAUSE_HUB_URL;
  };

  handleCancel = () => {
    FPT.trackLinkClick('cancel');
    window.location.href = templateData.charityReturnUrl;
  };

  getActionElementType() {
    // For US and GB, return 'View Nonprofits on Paypal'
    if (templateData.country === 'US' || templateData.country === 'GB') {
      return FUNDRAISER_BUTTON;
    } else {
      const orgName = templateData.donationName || '';
      if (templateData.charityReturnUrl && orgName) {
        return CANCEL_AND_RETURN_LINK;
      }
    }
    // Default to US behaviour
    return FUNDRAISER_BUTTON;
  }

  renderActionButton() {
    const buttonText = _get(messages, 'label.nonprofits');
    return (
      <div style={{ maxWidth: 360, margin: '40px auto 0px' }}>
        {this.getActionElementType() === CANCEL_AND_RETURN_LINK ? (
          this.renderCancelAndReturnButton()
        ) : (
          <Button
            className="btn-wide"
            id="tryAgain"
            onClick={this.handleReturn}
          >
            {buttonText}
          </Button>
        )}
      </div>
    );
  }

  renderCancelAndReturnButton() {
    let labelreturn = _get(cancelAndReturnMessages, 'label.return', '');
    labelreturn = labelreturn.replace(
      '{orgName}',
      sanitize(templateData.donationName)
    );

    return (
      <div className="ppvx_col-12 pp_cancel_btn_wrapper text-center">
        <a
          href="#"
          className="pp_cancel_btn"
          style={{ padding: 0 }}
          id="cancelReturnBtn"
          onClick={this.handleCancel}
          dangerouslySetInnerHTML={{ __html: labelreturn }}
        ></a>
      </div>
    );
  }

  render() {
    const {
      error: { header1 = '', line1 = '', line2 = '' },
      label: { nonprofits = '' },
    } = messages || {};

    return (
      <div
        className={`donate_wrapper confirmation ${
          isMobileHeaderExp() ? 'mobile_view' : ''
        }`}
      >
        <div className="ppvx_row">
          <div className="ppvx_col-12 text-center">
            <div className="confirmation_img_holder center-block">
              <Illustration type="warning" />
            </div>
          </div>
        </div>
        <div className="ppvx_row">
          <div className="ppvx_col-12">
            <div className="confirmation_header">
              <Text size="xl" regular className="text-center">
                {header1}
              </Text>
            </div>
          </div>
        </div>

        <div className="ppvx_row">
          <div className="ppvx_col-12">{this.renderActionButton()}</div>
        </div>
      </div>
    );
  }
}

ReactDOM.render(<MemberPage />, document.getElementById('donateWrapper'));
